import { createContext, useContext } from 'react';
import { createPortal } from 'react-dom';

// WindowFrame exposes a DOM node inside its title bar; panel components render
// their header controls into it so each window has a single header row.
// Outside a WindowFrame (mobile panels) the context is null and PanelHeader
// falls back to the panel's own inline header.
export const PanelHeaderSlotContext = createContext(null);

export function usePanelHeaderSlot() {
  return useContext(PanelHeaderSlotContext);
}

// Shared header for analysis panels. `title` is the panel's own title element
// (only rendered in the inline fallback — the WindowFrame title bar already
// names the window); `className` is the panel's inline-header class.
export default function PanelHeader({ title, className, children }) {
  const slot = usePanelHeaderSlot();
  if (slot) return createPortal(children, slot);
  return (
    <div className={className}>
      {title}
      {children}
    </div>
  );
}
